export default "__VITE_ASSET__Cas5QHGH__"